import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedNoteType: "",
  loading: false,
  addNoteLoading: false,
  loadingNote_Types: false,

  notes: [],
  billingnotes:[],
  noteTypes: [],
  allNotesTypes: [],
  fieldType: [],
  notesAgainstTypes: [],
  singleNote : null,
  notePageloading: false,
  noteReport: null,
  noteReportLoading: false,
};

export const noteState = createSlice({
  name: "notes",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload
      };
    },
    setLoadingNote_Types(state, action) {
      return {
        ...state,
        loadingNote_Types: action?.payload
      };
    },
    setAddNoteLoading(state, action) {
      return {
        ...state,
        addNoteLoading: action?.payload
      };
    },
    setNotePageLoaging(state, action) {
      return {
        ...state,
        notePageloading: action?.payload
      };
    },
    setNotes(state, action) {
      return {
        ...state,
        loading: false,
        addNoteLoading: false,
        notes: action?.payload
      };
    },
    clearNotes(state) {
      state.notes = [];
    },

    setSingleNote(state, action) {
      return {
        ...state,
        loading: false,
        singleNote: action?.payload
      };
    },

    setBillingNotes(state, action) {
      return {
        ...state,
        loading: false,
        addNoteLoading: false,
        billingnotes: action?.payload
      };
    },



    setNoteTypes(state, action) {
      return {
        ...state,
        loading: false,
        noteTypes: action?.payload
      };
    },
    setAllNotesTypes(state, action) {
      return {
        ...state,
        loading: false,
        addNoteLoading: false,
        allNotesTypes: action?.payload
      };
    },
    setFieldTypes(state, action) {
      return {
        ...state,
        loading: false,
        fieldType: action?.payload
      };
    },
    setNoteType(state, action) {
      return {
        ...state,
        selectedNoteType: action?.payload
      };
    },
    setNotesAgainstType(state, action) {
      return {
        ...state,
        notesAgainstTypes: action?.payload,
        loadingNote_Types: false
      };
    },
     setNote_Report(state, action) {
      return {
        ...state,
        noteReport: action?.payload,
      };
    },
    setLoadingNote_Report(state, action) {
      return {
        ...state,
        noteReportLoading: action?.payload
      };
    },

    // Reset State
    reset() {
      return initialState;
    }
  }
});

export const {
  setLoading,
  setNotePageLoaging,
  setAddNoteLoading,
  setNotes,
  clearNotes,
  setSingleNote,
  setBillingNotes,
  setClearBillingNotes,
  setNoteTypes,
  setFieldTypes,
  setNoteType,
  setAllNotesTypes,
  setLoadingNote_Types,
  setNote_Report,
  setLoadingNote_Report,
  setNotesAgainstType
} = noteState.actions;
export default noteState.reducer;
